export const waUrl = (digits, msg) => `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;

export const reorderMessage = (shopName, items = []) =>
  `Hello ${shopName}, mujhe apna previous order dobara order karna hai${items.length ? `: ${items.join(", ")}` : ""}. Please confirm availability.`;

export const isNewItem = (createdAt) => {
  const t = Date.parse(createdAt || "");
  if (Number.isNaN(t)) return false;
  const age = Date.now() - t;
  return age >= 0 && age < 24 * 60 * 60 * 1000;
};
